<template>
  <div class="acPreloader" role="status" aria-label="Загрузка">
    <div class="acPreloader__spinner" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AcPreloader'
})
</script>

<style lang="scss" scoped>
.acPreloader {
  color: currentColor;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
}

.acPreloader__spinner {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid rgba(140, 107, 249, 0);
  border-top-color: currentColor;
  border-right-color: currentColor;
  animation: acPreloaderSpin 0.9s linear infinite;
}

@keyframes acPreloaderSpin {
  to {
    transform: rotate(360deg);
  }
}
</style>
